
<template>
  <div id="app">
    <router-view></router-view>
    <footer>
          <div class="max">
            <p>地址：北京市西城区百万庄大街22号</p>
            <p>邮编：100037 电话：010-68323566 传真：010-88386228</p>
            <p>Copyright©北京中房研协技术服务有限公司，All Right Reserved <a href="http://www.beian.miit.gov.cn/" style="color:#fff;">京ICP备13002607号</a> 京公网安备110102000179</p>
            <div class="icon">
                <a href="http://www.fangchan.com" target="_blank"><span class="fangchan"></span></a>
                <span class="wechat"></span>
                <span class="weibo"></span>
                <span class="totop"></span>
            </div>
          </div>
          <div class="min">
            <p>Copyright©中房网，All Right Reserved</p>
          </div>
    </footer>
    <div class="fangchan-pic">
        中房网
        <span class="v"></span>
    </div>
    <div class="wechat-pic">
        <img src="http://src.leju.com/imp/imp/deal/0d/da/b/99c01649a9e749faf3bc655081c_p24_mk24.jpg"  width="95" height="95"/>
        <span class="v"></span>
    </div>
    <div class="weibo-pic">
        <img src="http://src.house.sina.com.cn/imp/imp/deal/73/3f/c/5c73d70e394f28441b1962e3219_p24_mk24.jpg" />
        <span class="v"></span>
    </div>
    <div class="totop-pic">
        返回顶部
        <span class="v"></span>
    </div>

  </div>  
</template> 
<script>
export default {
  name: 'app',
  mounted: function(){
    //底部图标
    $('.wechat').mouseenter(function(){
        var w = $(document.body).width();
        var y = $(this).offset().left;
        var r = w - y - (46 * 1.5) - 6;
        $('.wechat-pic').css('right',r + 'px');
        $('.wechat-pic').show();
    });
    $('.wechat').mouseleave(function(){
        $('.wechat-pic').hide();
    })

    $('.weibo').mouseenter(function(){
        var w = $(document.body).width();
        var y = $(this).offset().left;
        var r = w - y - (46 * 1.5) - 6;
        $('.weibo-pic').css('right',r + 'px');
        $('.weibo-pic').show();
    });
    $('.weibo').mouseleave(function(){
        $('.weibo-pic').hide();
    })

    $('.totop').mouseenter(function(){
        var w = $(document.body).width();
        var y = $(this).offset().left;
        var _thisW = $('.totop-pic').width();
        var r = w - y - _thisW - 3;
        $('.totop-pic').css('right',r + 'px');
        $('.totop-pic').show();
    });
    $('.totop').mouseleave(function(){
        $('.totop-pic').hide();
    });

    $('.totop').click(function(){
        $(document.documentElement).animate({scrollTop:0},200);
        $(document.body).animate({scrollTop:0},200);
    });

    $('.fangchan').mouseenter(function(){
        var w = $(document.body).width();
        var y = $(this).offset().left;
        var _thisW = $('.fangchan-pic').width();
        var r = w - y - _thisW - 10;
        $('.fangchan-pic').css('right',r + 'px');
        $('.fangchan-pic').show();
    });
    $('.fangchan').mouseleave(function(){
        $('.fangchan-pic').hide();
    });

    $('.fangchan').click(function(){
        $(document.documentElement).animate({scrollTop:0},200);
        $(document.body).animate({scrollTop:0},200);
    });
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue